import React from 'react';
import { Button, Col, Row, Alert } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { Container } from 'react-bootstrap';

import { PublicLayout, ResourceContent } from '../components';
import { navigateToLogin, navigateToRegistration } from '../redux';
import { rawSafeHtmlProps, getConfigurationDataKey } from '../utils';
import { clientApplicationNameSelector } from '../utils';
import { useSelector } from 'react-redux';
import { AppRootState } from '../redux';
import { AnyType } from '../interfaces';

export const RegistrationWelcomeView = () => {
  const dispatch = useDispatch();
  const applicationName = useSelector(clientApplicationNameSelector);

  const email_field_registration_welcome_page = useSelector(
    (state: AppRootState) =>
      ((state.app?.entities?.features as AnyType) ?? {})['email_field_for_registration_welcome_page'] as AnyType
  );

  return (
    <div className='w-55 mt-3'>
      <Row>
        <Col lg={8}>
          <div className='header-section-text mb-2'>
            <ResourceContent
              contentKey={getConfigurationDataKey('registration.title')}
              sourceDataKey='content'
              render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
            />
          </div>
          <ResourceContent
            contentKey={getConfigurationDataKey('registration.body')}
            sourceDataKey='content'
            render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
          />
        </Col>
        <Col lg={1} />

        <Col sm={5} lg={3}>
          <Alert variant='success' style={{ width: 'max-content', height: 'fit-content' }}>
            <ResourceContent
              contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
              sourceDataKey='content'
              render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
            />
            <table className='mb-4 ms-2'>
              <tbody>
                <tr>
                  <th>Phone:</th>
                  <td className='pl-4'>
                    <ResourceContent
                      contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                      sourceDataKey='phone'
                      render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
                    />
                  </td>
                </tr>
                <tr>
                  <th className='pt-2'>Fax:</th>
                  <td className='pl-4 pt-2'>
                    <ResourceContent
                      contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                      sourceDataKey='fax'
                      render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
                    />
                  </td>
                </tr>

                {email_field_registration_welcome_page?.data?.enabled == true ? (
                  <tr>
                    <th className='pt-2'>Email:</th>
                    <td className='pl-4 pt-2'>
                      <ResourceContent
                        contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                        sourceDataKey='email'
                        render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
                      />
                    </td>
                  </tr>
                ) : (
                  ''
                )}
              </tbody>
            </table>
            <p className='mb-0'>
              <ResourceContent
                contentKey={getConfigurationDataKey('registration.submitted.assistance_notice')}
                sourceDataKey='hours'
                render={(body) => <span {...rawSafeHtmlProps(body?.toString())} />}
              />
            </p>
          </Alert>
        </Col>
      </Row>
    </div>
  );
};
